import { render, staticRenderFns } from "./orderItemDailyChartWidget.vue?vue&type=template&id=0680f732&"
import script from "./orderItemDailyChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderItemDailyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports